package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.MemberRepository
import com.clany.backoffice.model.MemberResponse
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class MemberRepositoryImpl(
    private val networkClient: NetworkClient
) : MemberRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getMembers(page: Int, pageSize: Int, query: String?): Result<List<MemberResponse>> {
        return networkClient.request<List<MemberResponse>>("$baseUrl/api/members") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (query != null) parameter("q", query)
        }
    }

    override suspend fun deleteMember(id: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/members/$id", HttpMethod.Delete)
    }
}
